import "./thank-you-page.scss";

(function () {
    if (document.querySelectorAll(".js-thank-you-page").length > 0) {

        const thankYouPage = {
            init: function () {
                const pageUrl = document.getElementById("page-url");
                const exitUrl = document.getElementById("exit-url");
                const redirectDelay = document.getElementById("redirect-delay");
                const redirectUrl = document.getElementById("redirect-url");
                let pageUrlValue = "";
                let exitUrlValue = "";
                let redirectUrlValue = "";

                if (pageUrl != null) {
                    pageUrlValue = pageUrl.value;
                }

                if (exitUrl != null) {
                    exitUrlValue = exitUrl.value;
                }

                if (redirectUrl != null) {
                    redirectUrlValue = redirectUrl.value;
                }

                if (window.dataLayer !== undefined) {
                    window.dataLayer.push({
                        pageUrl: pageUrlValue,
                        "Form Url": document.referrer,
                        "Exit Url": exitUrlValue,
                    });
                }

                if (redirectDelay != null) {
                    redirectDelayValue = redirectDelay.value;

                    const delayInSeconds = Number(redirectDelayValue) * 1000;

                    setTimeout(function () {
                        window.location.href = redirectUrlValue;
                    }, delayInSeconds);
                }
            },
        };

        thankYouPage.init();
    }
})();
